import KeyLine from 'components/shared/KeyLine';
import type { KeylineProps } from './types';

const Keyline = (_props: KeylineProps) => (
  <div className="content-wrapper">
    <KeyLine />
  </div>
);

export default Keyline;
